/**
 * 
 * @returns boolean if browser can copy to clipboard
 * 
 */
export const canCopy = (): boolean => {
  return !!navigator.clipboard;
};
